module.exports = "\n<div class=\"container-fluid\">\n<router-outlet>\n</router-outlet>\n</div>\n\n"